module.exports = __webpack_public_path__ + "img/goro-fujita-enoki-tales.301a16e.jpg";